import { render } from "./BulkDuplicateModal.vue?vue&type=template&id=267f5d8e&scoped=true"
import script from "./BulkDuplicateModal.vue?vue&type=script&lang=js"
export * from "./BulkDuplicateModal.vue?vue&type=script&lang=js"

import "./BulkDuplicateModal.vue?vue&type=style&index=0&id=267f5d8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267f5d8e"]])

export default __exports__